import { render, staticRenderFns } from "./FormQuizzBasicInfo.vue?vue&type=template&id=45470e48&scoped=true&"
import script from "./FormQuizzBasicInfo.vue?vue&type=script&lang=js&"
export * from "./FormQuizzBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormQuizzBasicInfo.vue?vue&type=style&index=0&id=45470e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45470e48",
  null
  
)

export default component.exports